import { studentName, compareStudentNames } from "../../core/utils/studentName";
import { useState, useEffect, useRef } from "react";
import Avvvatars from "avvvatars-react";
import { Link } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import { StudentDataTable } from "../../core/data/interface/index";
import {
  getAllStudentByYear,
  getAllStudents,
  deleteStudent,
  getStudentById,
  deteleStudentRegistration,
} from "../../api/etudiants";
import { recoverAccount } from "../../api/users";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "sonner";
import CommonSelect from "../../core/common/commonSelect";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { getAllClass } from "../../api/pedagogicElement";
import { getStudentRegistrationByClass } from "../../api/etudiants";
import TooltipOption from "./tooltipOption";
import InfosAlertYearDisabled from "../../core/common/alerts/infosAlertYearDisabled";

import { useCurrentClass } from "../../core/common/context/studentClassContext";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";
import DashboardMenu from "../user/admin/dashboardMenu";

//  bouton protégé pour ajouter une inscription
const ProtectedAddStudent = withPermission(
  (props: any) => (
    <div className="mb-2">
      <Link
        to="/registration-student"
        className="btn btn-primary d-flex align-items-center"
        onClick={() => {}}
      >
        <i className="ti ti-square-rounded-plus me-2" />
        Nouvelle Inscription
      </Link>
    </div>
  ),
  [buildPermission(Resource.STUDENT, Action.CREATE)],
  "masquer",
);

//  bouton protégée pour supprimer une inscription
const ProtectedDeleteRegistration = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item rounded-1"
        onClick={() => props.showdeleteStudentConfirmationAlert(props.record)}
        // disabled={!selectedYear?.statut || false}
      >
        <i className="ti ti-trash-x me-2" />
        {props.label || "Supprimer l’inscription"}
      </button>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.DELETE)],
  "masquer",
);

// bouton pour réinitialiser un mot de passe
const ProtectedBtnResetPasword = withPermission(
  (props: any) => (
    <li>
      <button
        disabled={!props.record.email}
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
      >
        <i className="ti ti-menu me-2" />
        Mot de passe
      </button>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

const AllStudent = () => {
  const routes = my_routes;
  const { selectedYear } = useAcademicYear();
  const { currentClass, setCurrentClass } = useCurrentClass();
  // Initialisation des state utilisés
  const loadVersion = useRef(0);
  const [withoutClass, setWithoutClass] = useState(false);
  const [allStudents, setAllStudents] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données
  const [updateData, setUpdateData] = useState(false); // Mettre à jour les modifications visuellement
  const [allClass, setAllClass] = useState<{ value: string; label: string }[]>(
    [],
  );

  const [column, setColumn] = useState<any[]>([]);

  useEffect(() => {
    const fetchClassByYear = async () => {
      try {
        if (!selectedYear?.id) return;

        const response = await getAllClass(
          selectedYear?.id,
          buildPermissionContext(Resource.STUDENT, Action.READ),
        );

        const formattedData = response.data
          .slice() // pour éviter de modifier directement la réponse
          .sort((a: any, b: any) => {
            // Tri par Level.label
            const levelCompare = a.Level.label.localeCompare(
              b.Level.label,
              "fr",
              { numeric: true },
            );
            if (levelCompare !== 0) return levelCompare;

            // Si même Level, tri par class label
            return a.label.localeCompare(b.label, "fr", { numeric: true });
          })
          .map((classItem: any) => ({
            value: classItem.id,
            label: `${classItem.Level.label} - ${classItem.label}`,
          }));

        setAllClass(formattedData);
      } catch (error: any) {
        // console.log("erreur lors de la récupération des classes: ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
      }
    };
    fetchClassByYear();
  }, [selectedYear]);

  const fetchStudentData = async () => {
    const version = ++loadVersion.current;
    try {
      if (withoutClass) {
        const response = await getAllStudents(
          buildPermissionContext(Resource.STUDENT, Action.READ),
          { withoutClass: true },
        );
        if (version !== loadVersion.current) return;
        setAllStudents(response.data);
        setIsLoading(false);
        setHasLoaded(true);
        setUpdateData(false);
      } else if (currentClass?.value) {
        const response = await getStudentRegistrationByClass(
          currentClass?.value,
        );
        const formattedData = await Promise.all(
          response.data.map(
            async (studentItem: any) =>
              await getStudentById(studentItem.id_studentProfil),
          ),
        );

        if (version !== loadVersion.current) return;
        setAllStudents(
          formattedData.map((studentItem: any) => studentItem?.data),
        );
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
        setUpdateData(false); // les données ont été mise à jour !
      } else {
        if (!selectedYear?.id) return;
        const response = await getAllStudentByYear(selectedYear.id);
        // console.log("All student by year: ", response);
        const studentWithClass = response.data.map((studentItem: any) => {
          return {
            ...studentItem,
            class: studentItem?.Registrations[0]?.Class,
          };
        });

        // console.log("student with class: ", studentWithClass);
        // console.log("allstudent without specific class: ", response.data);
        if (version !== loadVersion.current) return;
        setAllStudents(studentWithClass);
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
        setUpdateData(false); // les données ont été mise à jour !
      }
    } catch (error: any) {
      if (version !== loadVersion.current) return;
      setIsLoading(false);
      setHasLoaded(true);
      // console.error("Erreur lors de la récupération des étudiants:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };
  
  useEffect(() => {
    fetchStudentData();
  }, [updateData, currentClass, selectedYear, withoutClass]);
  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  //Traitement en alert de la demande de réinitialisation de mot de passe
  const showConfirmationAlert = (user: any) => {
    MySwal.fire({
      title: "Réinitialiser mot de passe ?",
      text: `Un e-mail contenant un lien sécurisé lui sera envoyé à ${user.firstname} ${user.lastname} pour lui permettre de définir un nouveau mot de passe.`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Réinitialisation en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await recoverAccount(user.email);
          MySwal.fire({
            title: "Lien envoyé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de l'envoi de l'e-mail. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // alert pour supprimer de l'insciption de l'étudiant
  const showdeleteStudentConfirmationAlert = (student: any) => {
    MySwal.fire({
      title: "Supprimer inscription ?",
      text: `Voulez-vous vraiment supprimer l'inscription de ${student.firstname} ${student.lastname} de l'année ${selectedYear?.label} ?`,
      showCancelButton: true,
      confirmButtonText: "Supprimer!",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête de suppression
          await deteleStudentRegistration(selectedYear?.id, student.id);
          // await deleteStudent(student.id);
          MySwal.fire({
            title: "Inscription supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          setAllStudents((prev) =>
            prev.filter((studentItem) => studentItem.id !== student.id),
          );
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          // console.log("Echec de la suppression de l'inscription: ", error);
          MySwal.fire({
            title: "Erreur",
            text: "Échec de la suppression de l'étudiant. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };
  const confirmDeleteStudent = async (student: any) => {
    const result = await MySwal.fire({
      title: "Supprimer définitivement cet étudiant ?",
      text: `Le profil de ${student.lastname} ${student.firstname} sera supprimé de la base, toutes années confondues. Cette action est irréversible.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Supprimer l’étudiant",
      cancelButtonText: "Annuler",
    });
    if (!result.isConfirmed) return;
    MySwal.fire({ title: "Suppression en cours...", allowOutsideClick: false,
      allowEscapeKey: false, showConfirmButton: false,
      didOpen: () => MySwal.showLoading() });
    try {
      await deleteStudent(student.id, buildPermissionContext(Resource.STUDENT, Action.DELETE));
      setAllStudents(prev => prev.filter(item => item.id !== student.id));
      await MySwal.fire({ title: "Étudiant supprimé", icon: "success" });
    } catch (error: any) {
      await MySwal.fire({ title: "Suppression impossible", icon: "error",
        text: error.response?.data?.message || "La suppression a échoué. Veuillez réessayer." });
    }
  };

  // On met à jour les colonnes du tableau en fonction de la classe sélectionnée
  useEffect(() => {
    if (
      !withoutClass && currentClass &&
      currentClass?.value !== "" &&
      currentClass?.value !== undefined
    ) {
      setColumn([
        {
          title: "Nom prénom",
          dataIndex: "studentName",
          sorter: compareStudentNames,
          defaultSortOrder: "ascend",
          render: (text: string, record: any) => (
            <div className="d-flex align-items-center">
              <Link
                to={`/student-detail/${record.id}`}
                className="avatar avatar-md"
              >
                <Avvvatars
                  value={`${record.firstname?.charAt(0) || ""}${
                    record.lastname?.charAt(0) || ""
                  }`}
                  style="character" // ou "character"
                />
              </Link>
              <div className="ms-2">
                <p className="text-dark mb-0">
                  <Link
                    to={`/student-detail/${record.id}`}
                  >{studentName(record)}</Link>
                </p>
                <span className="fs-12">{record.matricule}</span>
              </div>
            </div>
          ),
        },

        {
          title: "Sexe",
          dataIndex: "sexe",
          sorter: (a: StudentDataTable, b: StudentDataTable) =>
            a.sexe.length - b.sexe.length,
        },
        // {
        //   title: "Adresse",
        //   dataIndex: "adresse",
        //   sorter: (a: ParentDataTable, b: ParentDataTable) =>
        //     a.adresse.length - b.adresse.length,
        // },
        // {
        //   title: "Birthday",
        //   dataIndex: "birthday",
        //   sorter: (a: StudentDataTable, b: StudentDataTable) =>
        //     a.birthday.length - b.birthday.length,
        // },
        // },
        {
          title: "Email",
          dataIndex: "email",
          sorter: (a: StudentDataTable, b: StudentDataTable) =>
            a?.email?.length - b?.email?.length,
        },
        {
          title: "Téléphone",
          dataIndex: "number",
          sorter: (a: StudentDataTable, b: StudentDataTable) =>
            a?.number?.length - b?.number?.length,
        },
        {
          title: "Statut",
          dataIndex: "statut",
          render: (text: boolean) => (
            <>
              {text == true ? (
                <span className="badge badge-soft-success d-inline-flex align-items-center">
                  <i className="ti ti-circle-filled fs-5 me-1"></i>
                  Actif
                </span>
              ) : (
                <span className="badge badge-soft-danger d-inline-flex align-items-center">
                  <i className="ti ti-circle-filled fs-5 me-1"></i>
                  Inactif
                </span>
              )}
            </>
          ),
          sorter: (a: StudentDataTable, b: StudentDataTable) =>
            a.statut === b.statut ? 0 : a.statut ? -1 : 1,
        },
        // {
        //   title: "Date d'inscription",
        //   dataIndex: "createdAt",
        //   render: (date: string) => {
        //     const d = new Date(date);
        //     return d.toLocaleDateString("fr-FR", {
        //       year: "numeric",
        //       month: "long",
        //       day: "numeric",
        //       hour: "2-digit",
        //       minute: "2-digit",
        //     });
        //   },
        //   sorter: (a: ParentDataTable, b: ParentDataTable) =>
        //     new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
        // },
        {
          title: "Action",
          dataIndex: "action",
          render: (_: any, record: any) => {
            return (
              <>
                <div className="d-flex align-items-center">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="ti ti-dots-vertical fs-14" />
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-right p-3">
                      <li>
                        <Link
                          className="dropdown-item rounded-1"
                          to={`/student-detail/${record.id}`}
                          onClick={async () => {
                            // await getParentChildren(record.id);
                            // setParentDetail(
                            //   allParents.find((parent) => parent.id === record.id)
                            // );
                            // setShow(true);
                          }}
                        >
                          <i className="ti ti-menu me-2" />
                          Détails Etudiant
                        </Link>
                      </li>
                      {/* <li>
                    <Link
                      className="dropdown-item rounded-1"
                      // data-bs-toggle="modal"
                      // data-bs-target="#edit_parent_modal"
                      to={`/edit-student/${record.id}`}
                      // onClick={() => {
                      //   // setEditParent(
                      //   //   allParents.find((parent) => parent.id === record.id)
                      //   // );

                      // }}
                    >
                      <i className="ti ti-edit-circle me-2" />
                      Modifier
                    </Link>
                  </li> */}
                      {/* reinitialiser mot de passe */}
                      <ProtectedBtnResetPasword
                        record={record}
                        showConfirmationAlert={showConfirmationAlert}
                      />

                      {/* supprimer inscription */}
                      {!withoutClass && <ProtectedDeleteRegistration
                        showdeleteStudentConfirmationAlert={showdeleteStudentConfirmationAlert}
                        record={record}
                      />}
                      <ProtectedDeleteRegistration
                        label="Supprimer l’étudiant"
                        showdeleteStudentConfirmationAlert={confirmDeleteStudent}
                        record={record}
                      />
                    </ul>
                  </div>
                </div>
              </>
            );
          },
        },
      ]);
      return;
    }

    setColumn([
      {
        title: "Nom prénom",
        dataIndex: "studentName",
          sorter: compareStudentNames,
          defaultSortOrder: "ascend",
        render: (text: string, record: any) => (
          <div className="d-flex align-items-center">
            <Link
              to={`/student-detail/${record.id}`}
              className="avatar avatar-md"
            >
              <Avvvatars
                value={`${record.firstname?.charAt(0) || ""}${
                  record.lastname?.charAt(0) || ""
                }`}
                style="character" // ou "character"
              />
            </Link>
            <div className="ms-2">
              <p className="text-dark mb-0">
                <Link
                  to={`/student-detail/${record.id}`}
                >{studentName(record)}</Link>
              </p>
              <span className="fs-12">{record.matricule}</span>
            </div>
          </div>
        ),
      },

      {
        title: "Sexe",
        dataIndex: "sexe",
        sorter: (a: StudentDataTable, b: StudentDataTable) =>
          a.sexe.length - b.sexe.length,
      },
      {
        title: "Classe",
        dataIndex: "classe",
        render: (_: any, record: any) => {
          return (
            <>{record.class ? `${record.class?.Level?.label || ""} - ${record.class?.label || ""}` : "Sans classe"}</>
          );
        },
        sorter: (a: any, b: any) => {
          const labelA = `${a.class?.Level?.label || ""} - ${
            a.class?.label || ""
          }`.toLowerCase();
          const labelB = `${b.class?.Level?.label || ""} - ${
            b.class?.label || ""
          }`.toLowerCase();
          return labelA.localeCompare(labelB);
        },
      },
      // {
      //   title: "Adresse",
      //   dataIndex: "adresse",
      //   sorter: (a: ParentDataTable, b: ParentDataTable) =>
      //     a.adresse.length - b.adresse.length,
      // },
      // {
      //   title: "Birthday",
      //   dataIndex: "birthday",
      //   sorter: (a: StudentDataTable, b: StudentDataTable) =>
      //     a.birthday.length - b.birthday.length,
      // },
      // },
      {
        title: "Email",
        dataIndex: "email",
        sorter: (a: StudentDataTable, b: StudentDataTable) =>
          a?.email?.length - b?.email?.length,
      },
      {
        title: "Téléphone",
        dataIndex: "number",
        sorter: (a: StudentDataTable, b: StudentDataTable) =>
          a?.number?.length - b?.number?.length,
      },
      {
        title: "Statut",
        dataIndex: "statut",
        render: (text: boolean) => (
          <>
            {text === true ? (
              <span className="badge badge-soft-success d-inline-flex align-items-center">
                <i className="ti ti-circle-filled fs-5 me-1"></i>
                Actif
              </span>
            ) : (
              <span className="badge badge-soft-danger d-inline-flex align-items-center">
                <i className="ti ti-circle-filled fs-5 me-1"></i>
                Inactif
              </span>
            )}
          </>
        ),
        sorter: (a: StudentDataTable, b: StudentDataTable) =>
          a.statut === b.statut ? 0 : a.statut ? -1 : 1,
      },
      // {
      //   title: "Date d'inscription",
      //   dataIndex: "createdAt",
      //   render: (date: string) => {
      //     const d = new Date(date);
      //     return d.toLocaleDateString("fr-FR", {
      //       year: "numeric",
      //       month: "long",
      //       day: "numeric",
      //       hour: "2-digit",
      //       minute: "2-digit",
      //     });
      //   },
      //   sorter: (a: ParentDataTable, b: ParentDataTable) =>
      //     new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      // },
      {
        title: "Action",
        dataIndex: "action",
        render: (_: any, record: any) => {
          return (
            <>
              <div className="d-flex align-items-center">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-dots-vertical fs-14" />
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-right p-3">
                    <li>
                      <Link
                        className="dropdown-item rounded-1"
                        to={`/student-detail/${record.id}`}
                        onClick={async () => {
                          // await getParentChildren(record.id);
                          // setParentDetail(
                          //   allParents.find((parent) => parent.id === record.id)
                          // );
                          // setShow(true);
                        }}
                      >
                        <i className="ti ti-menu me-2" />
                        Détails Etudiant
                      </Link>
                    </li>
                    {/* <li>
                    <Link
                      className="dropdown-item rounded-1"
                      // data-bs-toggle="modal"
                      // data-bs-target="#edit_parent_modal"
                      to={`/edit-student/${record.id}`}
                      // onClick={() => {
                      //   // setEditParent(
                      //   //   allParents.find((parent) => parent.id === record.id)
                      //   // );

                      // }}
                    >
                      <i className="ti ti-edit-circle me-2" />
                      Modifier
                    </Link>
                  </li> */}

                    {/* reinitialiser mot de passe */}
                    <ProtectedBtnResetPasword
                      record={record}
                      showConfirmationAlert={showConfirmationAlert}
                    />

                    {/* supprimer inscription */}
                    {!withoutClass && <ProtectedDeleteRegistration
                        showdeleteStudentConfirmationAlert={showdeleteStudentConfirmationAlert}
                        record={record}
                      />}
                      <ProtectedDeleteRegistration
                        label="Supprimer l’étudiant"
                        showdeleteStudentConfirmationAlert={confirmDeleteStudent}
                        record={record}
                      />
                  </ul>
                </div>
              </div>
            </>
          );
        },
      },
    ]);
  }, [currentClass, selectedYear, withoutClass]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between">
            <DashboardMenu />
            {/* Boutton en entête de la page */}
            <div className="d-md-flex d-block align-items-center justify-content-between">
              {!withoutClass && <TooltipOption
                classObj={{
                  id: currentClass?.value,
                  label: currentClass?.label,
                }}
                updateData={fetchStudentData}
              />}
              <ProtectedAddStudent routes={routes} />
            </div>
          </div>
          {/* /Page Header */}
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          {/* Tableau liste des etudiants */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Liste des Etudiants</h4>
              <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                {/* Statistiques */}
                <div className="attendance-types">
                  <ul className="attendance-type-list d-flex align-items-center gap-3 mb-0">
                    <li className="d-flex align-items-center gap-2">
                      <span className="attendance-icon bg-success">
                        {
                          allStudents.filter(
                            (studentItem: any) =>
                              studentItem.sexe === "Masculin",
                          ).length
                        }
                      </span>
                      Homme
                    </li>

                    <li className="d-flex align-items-center gap-2">
                      <span className="attendance-icon bg-danger">
                        {
                          allStudents.filter(
                            (studentItem: any) =>
                              studentItem.sexe === "Feminin",
                          ).length
                        }
                      </span>
                      Femme
                    </li>

                    <li className="d-flex align-items-center gap-2">
                      <span className="attendance-icon bg-pending">
                        {allStudents.length}
                      </span>
                      Total
                    </li>
                  </ul>
                </div>

                {/* Select */}
                <div className="flex-grow-1" style={{ maxWidth: "400px" }}>
                  <label className="form-check mb-2">
                    <input type="checkbox" className="form-check-input"
                      checked={withoutClass}
                      onChange={event => {
                        setIsLoading(true);
                        setHasLoaded(false);
                        setWithoutClass(event.target.checked);
                      }} />
                    <span className="form-check-label">Sans classe (toutes années confondues)</span>
                  </label>
                  {!withoutClass && <CommonSelect
                    className={"select w-100"}
                    options={[{ value: "", label: "Select" }, ...allClass]}
                    defaultValue={currentClass}
                    onChange={(option: any) => {
                      setIsLoading(true);
                      setHasLoaded(false);
                      setCurrentClass(option);
                    }}
                  />}
                </div>
              </div>
            </div>

            <div className="card-body p-0 py-3">
              {/* Students List (On affiche le tableau qui si les données son chargées même vide) */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={column}
                  dataSource={allStudents}
                  Selection={true}
                />
              )}
              {/* /Students List */}
            </div>
          </div>
        </div>
      </div>
      {/* / Page Wrapper */}
    </>
  );
};

export default AllStudent;
